import jMoment from 'moment-jalaali';
import { INSTALLMENT_STATUS_CODE } from '../../../constants/Options';
import { PriceLabel } from 'components';

const columns = (currencyText) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه',
    field: 'id',
    align: 'center',
    filtering: false,
    sorting: false,
  },
  {
    title:`مبلغ (${currencyText})`,
    field: 'amount',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => <PriceLabel amount={rd.amount} />
  },
  {
    title: 'تاریخ ایجاد',
    field: 'dueDate',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => rd?.dueDate ? jMoment(rd?.dueDate).format('jYYYY/jMM/jD') : '-',
  },
  {
    title: 'وضعیت',
    field: 'status',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => INSTALLMENT_STATUS_CODE.find((s) => s.value === rd.status)?.label ?? '-',
  },
];

const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      ...row,
    };
  });

  return newData;
};

export { columns, generateData };
